module.exports = __webpack_public_path__ + "media/img/vca/step4-5f3093d8db685e8cc7e95d607c1e6459.png";